import { lazy } from 'react';
import {
    PORTAL_USUARIO_CRIAR,
    PORTAL_USUARIO_EDITAR,
    PORTAL_USUARIO_VISUALIZAR,
    PORTAL_HIERARQUIA_VISUALIZAR,
    PORTAL_AUDITORIA_VISUALIZAR,
    PORTAL_MENSAGEM_VISUALIZAR,
    PORTAL_AVISOS_VISUALIZAR,
    PORTAL_TREINAMENTOS_VISUALIZAR,
    PORTAL_SAUDE_VISUALIZAR,
    PORTAL_EQUIPAMENTOS_VISUALIZAR,
    PORTAL_STATUSTECNICOS_VISUALIZAR,
    PORTAL_CONHECIMENTO_VISUALIZAR
} from './permissoes';

const Hierarquia = lazy(() => import('../containers/pages/Hierarquia'));
const Usuario = lazy(() => import('../containers/pages/Usuario'));
const UsuarioLista = lazy(() => import('../containers/pages/UsuarioLista'));
const AuditoriaLista = lazy(() => import('../containers/pages/AuditoriaLista'));
const Auditoria = lazy(() => import('../containers/pages/Auditoria'));
const Mensagem = lazy(() => import('../containers/pages/Mensagem'));
const Avisos = lazy(() => import('../containers/pages/Avisos'));
const AvisoDetalhar = lazy(() => import('../containers/pages/AvisoDetalhar'));
const Treinamentos = lazy(() => import('../containers/pages/Treinamentos'));
const Saude = lazy(() => import('../containers/pages/Saude'));
const SaudeDetalhar = lazy(() => import('../containers/pages/SaudeDetalhar'));
const Equipamentos = lazy(() => import('../containers/pages/Equipamentos'));
const StatusTecnicos = lazy(() => import('../containers/pages/StatusTecnicos'));
const EquipamentoDetalhar = lazy(() => import('../containers/pages/EquipamentoDetalhar'));
const Conhecimento = lazy(() => import('../containers/pages/Conhecimento'));

const menuArray = [
    {
        texto: 'Usuários',
        path: `usuarios`,
        permissoes: [PORTAL_USUARIO_VISUALIZAR],
        component: UsuarioLista
    },
    {
        texto: 'Cadastro Usuários',
        path: `usuario/cadastrar`,
        permissoes: [PORTAL_USUARIO_CRIAR],
        component: Usuario
    },
    {
        texto: 'Editar Usuários',
        path: `usuario/editar`,
        permissoes: [PORTAL_USUARIO_EDITAR],
        component: Usuario,
        naoExibeSideBar: true
    },
    {
        texto: 'Editar Usuários',
        path: `usuario/ativacao`,
        permissoes: [PORTAL_USUARIO_EDITAR],
        component: Usuario,
        naoExibeSideBar: true
    },
    {
        texto: 'Visualizar Usuários',
        path: `usuario/visualizar`,
        permissoes: [PORTAL_USUARIO_VISUALIZAR],
        component: Usuario,
        naoExibeSideBar: true
    },
    {
        texto: 'Hierarquia',
        path: `hierarquia`,
        permissoes: [PORTAL_HIERARQUIA_VISUALIZAR],
        component: Hierarquia
    },
    {
        texto: 'Status Técnicos Dados',
        path: `statustecnicos`,
        permissoes: [PORTAL_STATUSTECNICOS_VISUALIZAR],
        component: StatusTecnicos
    },
    {
        texto: 'Auditoria de Evidências',
        path: `auditoria`,
        permissoes: [PORTAL_AUDITORIA_VISUALIZAR],
        component: AuditoriaLista
    },
    {
        texto: 'Auditoria de Evidências',
        path: `auditoria/visualizar/:idfoto`,
        permissoes: [PORTAL_AUDITORIA_VISUALIZAR],
        component: Auditoria,
        naoExibeSideBar: true
    },
    {
        texto: 'Mensagens',
        path: `mensagem`,
        permissoes: [PORTAL_MENSAGEM_VISUALIZAR],
        component: Mensagem
    },
    {
        texto: 'Avisos',
        path: `aviso`,
        permissoes: [PORTAL_AVISOS_VISUALIZAR],
        component: Avisos
    },
    {
        texto: 'Avisos',
        path: `aviso/detalhar/:idaviso`,
        permissoes: [PORTAL_AVISOS_VISUALIZAR],
        component: AvisoDetalhar,
        naoExibeSideBar: true
    },
    {
        texto: 'Treinamentos',
        path: `treinamentos`,
        permissoes: [PORTAL_TREINAMENTOS_VISUALIZAR],
        component: Treinamentos
    },
    {
        texto: 'Saúde',
        path: `saude`,
        permissoes: [PORTAL_SAUDE_VISUALIZAR],
        component: Saude
    },
    {
        texto: 'Saúde',
        path: `saude/detalhar/:id`,
        permissoes: [PORTAL_SAUDE_VISUALIZAR],
        component: SaudeDetalhar,
        naoExibeSideBar: true
    },
    {
        texto: 'Equipamentos',
        path: `equipamentos`,
        permissoes: [PORTAL_EQUIPAMENTOS_VISUALIZAR],
        component: Equipamentos
    },
    {
        texto: 'Equipamentos',
        path: `equipamentos/detalhar/:id`,
        permissoes: [PORTAL_EQUIPAMENTOS_VISUALIZAR],
        component: EquipamentoDetalhar,
        naoExibeSideBar: true
    },
    {
        texto: 'Gestão do Conhecimento SST',
        path: `conhecimento`,
        permissoes: [PORTAL_CONHECIMENTO_VISUALIZAR],
        component: Conhecimento
    },
];

export const listaMenuSideBar = () => {
    return menuArray.filter(r => !r.naoExibeSideBar);
};

export const listaMenu = () => menuArray;
